<template>
	<main>
		<div>
			<section v-for="group in groups" :key="group">
				<!-- <h2 class="group-name font-serif">{{ group }}</h2> -->
				<div class="characters">
					<div v-for="(npc, npcKey) in getCharacterObjectsByGroup( group )" :key="npcKey">
						<CharacterCard :npc="npc" :group="group"/>
					</div>
				</div>
			</section>
		</div>

		<div>
			<div class="abilities-sticky">
				<Abilities/>
			</div>
		</div>
	</main>
</template>


<script>
	// @TODO: Filters (boss/nonplayable/melee)
	import npc from '@/modules/data/npc'
	import CharacterCard from '@/components/CharacterCard'
	import Abilities from '@/components/Abilities'
	import { filterObjectByKeyValue } from '@/modules/utils/filterObjectByKeyValue';

	export default {
		name: 'Character',
		components: {
			CharacterCard,
			Abilities
		},
		data() {
			return {
				groups: [
					'Default',
					'Zombie',
					'Vampire',
					'Skeleton',
					'Demon',
					'Misc',
				],
			};
		},
		computed: {
			showUnplayableCharacters() {
				return this.$store.getters.getShowUnplayableCharacters;
			}
		},
		methods: {
			getCharacterObjectsByGroup( groupName )
			{
				let playable = npc;

				if ( !this.showUnplayableCharacters )
				{
					playable = filterObjectByKeyValue( npc, 'isPlayable', true )
				}

				return filterObjectByKeyValue( playable, 'group', groupName );
			},
		}
	}
</script>


<style scoped lang="scss">
	@import '@/assets/scss/_variables.scss';

	main {
		display: grid;
		grid-template-columns: auto 400px;
		position: relative;
	}

	.characters {
		display: grid;
		margin-bottom: 80px;
		grid-template-rows: auto;
		grid-column-gap: 20px;
		grid-row-gap: 30px;
		--grid-cols: 1;

		@media (min-width: 740px)  { --grid-cols: 1; }
		@media (min-width: 1030px) { --grid-cols: 2; }
		@media (min-width: 1330px) { --grid-cols: 3; }
		@media (min-width: 1830px) { --grid-cols: 4; }

		grid-template-columns: repeat(var(--grid-cols), 1fr);
	}

	.group-name {
		margin-bottom: 10px;
	}

	.abilities-sticky {
		padding: 0 40px;
		position: sticky;
		top: 120px;
	}
</style>
